import { createActions, createReducer } from "reduxsauce";

export const { Types, Creators } = createActions({
  setNewBudgetSaved: ['data']
});

const INITIAL_STATE: { isUpdate: boolean; } = { isUpdate: false };

const setNewBudgetSaved = (state = INITIAL_STATE, action: any) => ({ ...action.data });

export default createReducer(INITIAL_STATE, {
  [Types.SET_NEW_BUDGET_SAVED as any]: setNewBudgetSaved
});
